import React from 'react'


import banner from '../images/banner/banner1.png'

import { RiWhatsappLine } from "react-icons/ri";

const CourseTwo = () => {
    return (
        <>

            <div>

                <div className='relative font-[poppins]'>

                    <div className='relative'>
                        <img src={banner} className='w-full object-cover ' alt="" />
                        <div className='absolute top-0 w-full inset-0 backdrop-blur-sm  bg-black/30 md:bg-black/45'></div>
                    </div>

                    <div className='absolute top-10 md:top-40 left-8 right-8 md:left-20 '>

                        <h3 className='font-bold text-[14px] md:text-[44px] text-white uppercase text-center'> Short Term Course In </h3>
                        <h3 className='font-bold text-[14px] md:text-[44px] text-white uppercase text-center'> Visual Effects & Computer graphics</h3>

                    </div>

                </div>
            </div>

            <div>
                <section className='font-[poppins]  pt-8 md:pt-20  pb-8 md:pb-20'>
                    <div className=' w-full px-4 md:w-[80%] mx-auto'>

                        <div >
                            <h3 className='font-bold  text-[14px] md:text-[24px] text-gray-950 uppercase mb-2 md:mb-4 text-center md:text-start' >Course Objective</h3>
                            <p className='font-normal text-gray-700 text-[12px] md:text-[14px] text-justify md:text-start'>Dive into the world of visual effects and learn the essentials to bring your creative visions to life with our hands-on, immersive training. Develop industry-standard skills and techniques that will set you apart in the competitive film and media landscape.</p>
                        </div>



                        <div className='font-[poppins]  mt-8 md:mt-20'>

                            <div className='flex justify-center items-center'>
                                <h5 className=' text-[16px] md:text-[20px] uppercase font-bold tracking-[1px] md:tracking-[2px]'>Course Outline</h5>
                            </div>

                            <div className=' mt-4 md:mt-8'>

                                <div className='grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 md:gap-y-10 md:border border-gray-200 rounded-md  md:px-8 md:py-8' >

                                    <div className=' md:border-r border-gray-300'>
                                        <div>
                                            <h3 className='font-semibold text-[14px] md:text-[18px] text-gray-950 '>Unreal Engine for Filmmakers - 6 Months</h3>

                                            <div className=' mt-4 md:mt-6 flex flex-col gap-y-3'>

                                                <div>
                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>The course equips filmmakers with essential skills in Unreal Engine for creating advanced visual effects, immersive environments, and previsualization videos for feature film scenes.</li>
                                                        <li> Participants will learn real-time rendering techniques, scene creation, and the integration of visual effects to enhance film production with high-quality, dynamic visuals.</li>
                                                        <li>Hands-on projects emphasize utilizing Unreal Engine's capabilities to effectively plan and visualize feature film scenes.</li>

                                                    </ul>
                                                </div>


                                            </div>
                                        </div>
                                    </div>

                                    <div className=' md:pl-10'>
                                        <div>
                                            <h3 className='font-semibold text-[14px] md:text-[18px] text-gray-950 '>Motion Graphics with After Effects & Cinema 4D - 6 Months</h3>

                                            <div className=' mt-4 md:mt-6 flex flex-col gap-y-3'>

                                                <div>
                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>This course is tailored for aspiring motion graphics artists and animators who wish to master the art of creating dynamic visual content and character animations</li>
                                                        <li>This short-term course provides in-depth training on utilizing Adobe After Effects and Cinema 4D to produce professional-grade motion graphics and animated characters.</li>

                                                    </ul>
                                                </div>


                                            </div>
                                        </div>
                                    </div>

                                    <div className=' md:border-r border-gray-300'>
                                        <div>
                                            <h3 className='font-semibold text-[14px] md:text-[18px] text-gray-950 '>Stopmotion Animation - 6 Months</h3>

                                            <div className=' mt-4 md:mt-6 flex flex-col gap-y-3'>

                                                <div>
                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>This course focuses on teaching the principles and techniques essential for creating captivating animations frame-by-frame.</li>
                                                        <li>Students will learn to use industry-standard software - Dragonframe to explore storytelling through animation, and gain hands-on experience in animating characters and objects to bring their creative visions to life.</li>

                                                    </ul>
                                                </div>


                                            </div>
                                        </div>
                                    </div>

                                    <div className=' md:pl-10'>
                                        <div>
                                            <h3 className='font-semibold text-[14px] md:text-[18px] text-gray-950 '>Adobe Tools for Filmmakers - 6 Months</h3>

                                            <div className='mt-4 md:mt-6 flex flex-col gap-y-3'>

                                                <div>
                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>This course covers fundamentals of Adobe Premiere Pro for editing, After Effects for creating motion graphics and visual effects, Photoshop for image editing and compositing, Illustrator for designing graphics and titles, and Lightroom for color correction and photo enhancement.</li>
                                                        <li> Students learn to integrate these tools into their filmmaking workflow, from editing raw footage to adding special effects and creating polished final outputs.</li>

                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className=' md:border-r border-gray-300'>
                                        <div>
                                            <h3 className='font-semibold  text-[14px] md:text-[18px] text-gray-950 '>On-Set Visual Effects Supervisor - 6 Months </h3>

                                            <div className=' mt-4 md:mt-6 flex flex-col gap-y-3'>

                                                <div>
                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>This intensive course prepares participants to oversee visual effects on film sets, emphasizing pre-production planning, on-set supervision for seamless VFX integration, effective team communication, and real-time problem-solving. </li>
                                                        <li>Students will also learn crucial aspects like data handling and the VFX to grade studio roundtrip pipeline, ensuring comprehensive understanding of post-production workflows.</li>
                                                        <li> Students will emerge equipped with practical skills and industry knowledge essential for successful careers as on-set visual effects supervisors.</li>

                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>



                    </div>
                </section>
            </div>


            <div className=' w-[90%] md:w-[80%] mx-auto mb-10 '>
                <div className="flex justify-center items-center w-full h-full bg-white border border-dashed border-gray-300 rounded-md">
                    <div className='px-4 py-4 md:py-8 flex flex-col gap-y-4 md:gap-y-10 justify-center items-center my-auto h-full'>

                        <div>
                            <h3 className=' text-[14px] md:text-[18px]  font-semibold text-center uppercase'>Film Your Future with Us</h3>
                        </div>
                        <div className='mt-4 flex justify-center items-center'>
                            <a
                                href="https://api.whatsapp.com/send?phone=9884683888"
                                target="_blank"
                                rel="noopener noreferrer"

                            >
                                <button
                                    className={`bg-gray-900 text-white shadow-md drop-shadow-md h-9 pl-3 rounded-md flex items-center gap-x-3 font-[poppins] text-[12px] md:text-[14px] hover:scale-105 duration-500 `}
                                >
                                    Download syllabus
                                    <div className='px-3 bg-green-600 rounded-r-md'>
                                        <RiWhatsappLine className='text-white h-9 text-[22px] font-bold' />
                                    </div>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default CourseTwo
